import { Component, OnInit, ViewChild, EventEmitter, Output } from '@angular/core';
import { UserService } from '../../../services/userService/user.service';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-detail-sales-target',
  templateUrl: './detail-sales-target.component.html',
  styleUrls: ['./detail-sales-target.component.css']
})
export class DetailSalesTargetComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @Output() clearEvent = new EventEmitter<void>();

  displayedProductColumns: string[] = ['BusinessCategoryName', 'ProductBrandName', 'Origin', 'Code', 'Description', 'Specified', 'Qty', 'UnitType', 'Price', 'GrossValue', 'DiscountPer', 'TotalPrice', 'VatRate', 'TotalPriceWithVat', 'Competitor'];

  displayedTotalColumns: string[] = ['Total', 'BookingValue', 'BillingValue', 'TotalJan', 'TotalFeb', 'TotalMar', 'TotalApr', 'TotalMay', 'TotalJun', 'TotalJul', 'TotalAug', 'TotalSep', 'TotalOct', 'TotalNov', 'TotalDec'];

  id: any;
  isCollapsed: boolean = false;
  ProductDataSource: MatTableDataSource<any>;
  TotalRow: any;
  currentPage: any = 0;
  pageSize: any = 10;
  searchword_pro: any = '';
  inquiryProduct: any = []
  TotalProductRecord: number = 0;
  totalProductSize: number;
  permission: any;
  userRId: any;
  FinancialYear: any;
  decid: any;
  FinanceYear: any;

  constructor(
    private UserService: UserService,
    private router: Router,
    private toastr: ToastrService,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
  ) { }

  ngOnInit(): void {
    let permi = JSON.parse(localStorage.getItem("Permission"));
    this.permission = this.UserService.decryptData(permi);
    let userrId = localStorage.getItem('roleId');
    this.userRId = this.UserService.decryptData(userrId);
    if (this.permission.SalesTarget_View != 1 && this.userRId != 1) {
      this.toastr.error('You do not have permission');
      this.router.navigate(['/profile']);
    }
    let decid = this.route.snapshot.params['id'];
    decid = decid.toString().replace('Ar1t', '=').replace('FGH', '/').replace('THD', '+');
    this.id = this.UserService.decryptData(decid);

    let data = {
      "FinancialYear": this.id,
      "ItemPerPages": this.pageSize,
      "PageNo": this.currentPage + 1,
      "Export": false
    }
    this.UserService.GetSalesTargetDetailsByYear(data).subscribe((res) => {
      if (res['result'] == 'success') {
        this.spinner.hide();
        this.currentPage = 0;
        this.inquiryProduct = res['Data'];
        this.FinanceYear = res['FinancialYear']['FY_Year'];
        this.ProductDataSource = new MatTableDataSource<any>(res['Data']);
        this.ProductDataSource.paginator = this.paginator;
        this.totalProductSize = res['TotalRecord'];
        this.TotalRow = res['TotalRow'];
        setTimeout(() => {
          this.TotalProductRecord = this.totalProductSize;
        }, 500);
        this.P_iterator();
      }
    })
  }

  private P_iterator() {
    const end = (this.currentPage + 1) * this.pageSize;
    const start = this.currentPage * this.pageSize;
    const part = this.inquiryProduct.slice(start, end);
    this.ProductDataSource = part;
  }

  public ProducthandlePage(e: any) {
    this.spinner.show();
    this.currentPage = e.pageIndex;
    this.pageSize = e.pageSize;
    this.P_iterator();
    let data2 = {
      "FinancialYear": this.id,
      "SearchWord": this.searchword_pro,
      "Export": false,
      "ItemPerPages": this.pageSize,
      "PageNo": this.currentPage + 1
    }
    this.UserService.GetSalesTargetDetailsByYear(data2).subscribe((res) => {
      if (res['result'] == "success") {
        this.totalProductSize = res['TotalRecord'];
        this.TotalProductRecord = this.totalProductSize;
        this.spinner.hide();
        this.ProductDataSource = new MatTableDataSource<any>(res['Data']);
      }
    })
  }

  clearUserData() {
    const previousValue = this.searchword_pro;
    this.searchword_pro = '';
    if (previousValue && previousValue.length > 0 && previousValue !== this.searchword_pro) {
      this.clearEvent.emit();
    }
  }

  openClosefun() {
    this.isCollapsed = !this.isCollapsed;
  }

}
